import { Stats } from "_types/stats";

export const statsDummy: Stats = {
  ticker: "ticker",
  currIndex: 120,
  ts: "2000-01-01",
  price: 10.0,
  totPortValue: 500000,
  fundsAvail: 500000,
  posHeld: 0.0,
  posCost: 0.0,
  posPL: 0.0,
  posPLPerc: 0.0,
  status: "Trainer initialised.",
  rctTrade1: "most recent trade 1",
  rctTrade2: "most recent trade 2",
  rctTrade3: "most recent trade 3",
  rctTrade4: "most recent trade 4",
  rctTrade5: "most recent trade 5",
  stIndex: 120,
  stPortValue: 500000,
  endIndex: 5000,
  progress: 0.0,
  gain: 0.0,
};
